import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import isFunction from 'lodash/isFunction';

import './tab.scss';

class Tab extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'tab-button';

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { onSelect, onClick } = this.props;

    onSelect();

    if (isFunction(onClick)) {
      onClick();
    }
  }

  render() {
    const { isActive, disabled, children, routePathname, tabPath } = this.props;
    let linkDestination = null;

    if (routePathname) {
      linkDestination = {
        pathname: routePathname,
        hash: tabPath,
      };
    }

    return (
      <Link
        to={linkDestination}
        className={classnames(this.CLASS_NAME, {
          'tab-button--active': isActive,
          'tab-button--disabled': disabled,
          'tab-button--without-link-styles': routePathname,
        })}
        onClick={disabled ? null : this.handleOnClick}
      >
        {children}
      </Link>
    );
  }
}

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  routePathname: PropTypes.string,
  tabPath: PropTypes.string,
};

Tab.defaultProps = {
  disabled: false,
  isActive: false,
  onClick: () => {},
  onSelect: () => {},
  routePathname: null,
  tabPath: null,
};

export default Tab;
